import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useRealtimeUnits } from 'Core/hooks';

import { Grid, List, ListItem, ListItemText } from '@mui/material';
import { InputSearch } from 'Components';

import alertTypes from 'Modules/alerts/common/alertTypes.json';
// Core
import { HasPermission } from "Core/security"
import { useFeatureEnabled } from 'Components/FeatureToggle';
import { EVIRPX_ENABLED, INSPECTION_ALERT_TYPE } from 'Modules/evirPx/.globals/constants.ts'


const Step0 = (props) => {

    const showInspectionAlertType = useFeatureEnabled(EVIRPX_ENABLED, false);


    const filteredAlertTypes = alertTypes.filter(aType => {
        if (aType.code === INSPECTION_ALERT_TYPE && !showInspectionAlertType) {
            return false
        }
        return true
    })
    

    const { setCurrentStep, setCurrentAlert, currentAlert } = props

    const { messages } = useIntl()
    const units = useRealtimeUnits({ trackFields: ['id', 'name', 'label', 'disabled', 'driverId', 'vehicleStatusId', 'tags'] });
    const user = useSelector(state => state.securityRedux.user)
    const { alertTypesSupported } = useSelector((state) => state.alertsWizardRedux);


    const filteredAlertTypesSupported = alertTypesSupported.filter(aType => {
        if (aType.code === INSPECTION_ALERT_TYPE && !showInspectionAlertType) {
            return false
        }
        return true
    })
    const [searchType, setSearchType] = useState("")
    const [alertsSupported, setAlertsSupported] = useState([])


    useEffect(() => {
        if (filteredAlertTypesSupported) {
            let supported = [];
            supported = filteredAlertTypesSupported?.filter((alert) =>
                alert.parentId == null && alertsSupported.includes(alert.code)
            );

            let validationQueclink = units?.some((item) => (item?.unitVersionProduct === "GL500MG"))//&& process.env.ENVIROMENT === "production"

            if (!validationQueclink) {
                supported = supported?.filter((alert) => alert?.code !== "OnEvent");
            }
            
            const codesSupported = filteredAlertTypesSupported.map(m => m.code)
            filteredAlertTypes.map((alert) => {
                if(codesSupported.includes(alert.code)){
                    supported.push(alert)
                }
            });

            let hiddenAlerts = ["OBDIIAlerts", "OBDII", "Geofence","RouteWatchers"];//["DriverBehavior", "HeavyDutyDTC", "LightDutyDTC", "Motion", "Tow", "OBDIIAlerts", "OBDII", "ConsistentSpeed", "FuelCard"];
            if (!HasPermission(user, "mediaalerts", "212")) {
                hiddenAlerts.push("Media")
            }

            if (!HasPermission(user, "vidfleetvideo", [217])) {
                hiddenAlerts.push("CameraEvent");
            }
            
            if (!HasPermission(user, "fuel", [49])) {
                hiddenAlerts.push("FuelCard");
            }
            
            if (!HasPermission(user, "pFuelLev", [291])) {
                hiddenAlerts.push("FuelLevel");
            }

            supported = supported.filter(s => !hiddenAlerts.includes(s.code))

            supported = supported.sort((a, b) => {
                if (a.name?.toString()?.toLowerCase() > b.name?.toString()?.toLowerCase()) return 1;
                if (b.name?.toString()?.toLowerCase() > a.name?.toString()?.toLowerCase()) return -1;
                return 0;
            });
            setAlertsSupported(supported);
        }
    }, [filteredAlertTypesSupported])

    useEffect(() => {
        if (currentAlert?.id && alertsSupported) {
            let alert = filteredAlertTypes.find(x => x.code == currentAlert.type)
            setCurrentAlert(alert)
            setCurrentStep(1)
        }
    }, [currentAlert, alertsSupported])

    return (
        <Grid
            container
            justifyContent={'center'}
            direction={'column'}
        >
            <Grid item>
                <div style={{ marginBottom: '10px', paddingLeft: '20px', paddingRight: '20px' }}>
                    <div id='search-container' >
                        <div id='searchInputAlert' style={{ width: '95%', paddingTop: '20px' }} >
                            <InputSearch
                                onSearch={(txt) => {
                                    setSearchType(txt);
                                }}
                                searchText={searchType}
                            />
                        </div>
                    </div>

                    <List component='nav' aria-label='secondary mailbox folders'>
                        {
                            alertsSupported?.filter(
                                (alert) => searchType && messages['alertsNewAlert_' + alert.code]?.toLowerCase().includes(searchType.toLocaleLowerCase())
                                    || !searchType).map(alert => {
                                        const label = `${messages['alertsNewAlert_' + alert.code]}`

                                        return (
                                            <ListItem
                                                key={alert.code}
                                                className='alert-list-item'
                                                button
                                                onClick={() => {
                                                    const alertData = filteredAlertTypesSupported.find(x => x.code == alert.code)
                                                    setCurrentAlert({...alert, unitVersionIds: alertData?.unitVersionIds, conditions: alertData?.conditions})
                                                    setCurrentStep(1)
                                                }}
                                            >
                                                <ListItemText primary={label} />
                                            </ListItem>
                                        )
                                    })
                        }
                    </List>
                </div>
            </Grid>
        </Grid>
    )
}

export default Step0;
